module.exports = __webpack_public_path__ + "c74a21ca8c02ef14aaa6bc72e195b7a6.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/bluetoothOFF.mp4
// module id = 392
// module chunks = 0